export default __webpack_public_path__ + "static/media/18update-coaster1-superJumbo.985b9878.jpg";